import script from "./JobDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./JobDetails.vue?vue&type=script&setup=true&lang=js"

import "./JobDetails.vue?vue&type=style&index=0&id=a2e7f0e4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2e7f0e4"]])

export default __exports__